// @flow
import React, { Component } from 'react';
import type { BrandSequence } from 'store/modules/brands';
import { connect } from 'react-redux';
import type { State } from 'store';

import BrandSequences from 'components/brand/BrandSequences/BrandSequences';

type Props = {
  sequences: ?(BrandSequence[]),
  username: string,
  currentBrandId: string,
};

class BrandSequencesContainer extends Component<Props> {
  render() {
    const { sequences, username, currentBrandId } = this.props;

    return (
      <BrandSequences sequences={sequences} username={username} currentBrandId={currentBrandId} />
    );
  }
}

export default connect(
  ({ brands }: State) => ({
    sequences: brands.sequences,
    currentBrandId: brands.brand && brands.brand.id,
  }),
  () => ({}),
)(BrandSequencesContainer);



// WEBPACK FOOTER //
// ./src/containers/brand/BrandSequencesContainer.js